module.exports = __webpack_public_path__ + "static/media/property-management.2358aa5f.png";